// React
import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
} from "react-router-dom";

// Redux
import { Provider } from "react-redux";
import store from "./app/store";

// External Libraries
import { ThemeProvider, createTheme } from "@mui/material";
import { StyledEngineProvider, styled } from '@mui/material/styles';
import ReactGA from "react-ga4";
import { useGA4 } from "./app/googleAnalytics/constants";

// Components
import Header from "./app/components/header/Header";
import Footer from "./app/components/footer/Footer";
import Library from "./app/components/library/Library";
import Details from "./app/components/details/Details";
import About from "./app/components/staticpages/About";
import Usecases from "./app/components/staticpages/Usecases";
import Help from "./app/components/staticpages/Help";

const PREFIX = 'App';

const classes = {
  root: `${PREFIX}-root`,
  body: `${PREFIX}-body`,
  main: `${PREFIX}-main`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    overflow: "hidden",
    background: "#fafafa",
  },

  [`& .${classes.body}`]: {
    flex: "auto",
    padding: "0 7em",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "0 2em",
    },
  },

  [`& .${classes.main}`]: {
    flex: 1,
  }
}));

const theme = createTheme({
	breakpoints: {
    values: {
      xs: 600,
      sm: 960,
      md: 1200,
      lg: 1400,
      xl: 1536,
    },
  },
});

const App = () => {
  useGA4 && ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);

  const preventEvent = (event) => {
    try {
      event.preventDefault();
      return false;
    } catch (error) {
      console.error("event could not be canceled");
      return false;
    }
  };   

  useEffect(() => {
    // prevent HTML5: Overly Permissive Message Posting Policy
    // only allow messages from the applications origin
    window.addEventListener(
      "message",
      (event) => {
        event?.origin &&
          event.origin !== window.location.origin &&
          preventEvent(event);
        event?.originalTarget?.origin &&
          event.originalTarget.origin !== window.location.origin &&
          preventEvent(event);
        event?.target?.origin &&
          event.target.origin !== window.location.origin &&
          preventEvent(event);
        event?.source?.origin &&
          event.source.origin !== event.target.origin &&
          preventEvent(event);
      },
      false
    );
  }, []);

  const domain = "/hazus-loss-library/";

  return (
	<Root>
	    <StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
			    <Provider store={store}>
			      <Router basename={domain}>
			        <div className={classes.root} id="app-root">
			          <Header />
			          <main className={classes.main} id="app-main">
			            <div className={classes.body} id="app-body">
			              <Switch>
			                <Route path="/library" component={Library} />
			                <Route path="/details" component={Details} />
			                <Route path="/usecases" component={Usecases} />
			                <Route path="/about" component={About} />
			                <Route path="/help" component={Help} />
			              </Switch>
			            </div>
			          </main>
			          <Footer />
			        </div>
			      </Router>
			    </Provider>
			</ThemeProvider>
		</StyledEngineProvider>
	</Root>
  );
};

export default App;
